import React, { useMemo } from "react";
import AbstractTableContainer from "../shared/entity/components/AbstractTable/container";
import entityOptions from "./config/entity";
import supplierEntityOptions from "./config/supplierEntity"
import { getUserRoles } from "modules/auth/slice";
import { useSelector } from "react-redux";



export default function () {
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isUserSupplierPartner = useMemo(() => {
        if (getCurrentUserRoles?.includes("supplier_partner_account_manager")) {
            return true;
        }
        return false;
    }, [])

    return (
        <AbstractTableContainer
            options={isUserSupplierPartner ? supplierEntityOptions : entityOptions}
        // isFromClient={"fromClient"}
        />
    );
}
